import { cn } from 'utils/cn';
import { GLYPH_OWN_SIZE } from 'components/buttons/buttonStyle';
import { Clear as ClearIcon } from 'components/icons';
import { Button } from 'components/ui/button';
import React from 'react';

interface Props {
    title: string;
    onCancel: () => void;
    afterTitle?: React.ReactNode;
}

export const DrawerHeader = ({ title, onCancel, afterTitle }: Props): JSX.Element => (
    <div className="border-divider flex items-center justify-between border-b py-2.5 pr-[15px] pl-[23px]">
        <h2 className="text-h5 m-0 flex items-center gap-1">
            {title}
            {afterTitle ? afterTitle : null}
        </h2>
        <Button
            variant="ghost"
            size="icon-lg"
            aria-label="close"
            className={cn(GLYPH_OWN_SIZE, 'rounded-full')}
            onClick={onCancel}
        >
            <ClearIcon />
        </Button>
    </div>
);
